<template>
    <div class="content">
        <div style="display:  flex;flex-direction: row;">
          <el-button type="success" style="background-color: #2FBC82;" class="el-icon-plus" @click="AddClick"> 新增</el-button>
          <el-button type="primary" style="background-color: #2FBC82;" class="el-icon-money" @click="Recharge"> 充值</el-button>
        </div>
        


        <el-table :data='MerListData' border style="width: 100%;font-size:13px" stripe :highlight-current-row='true' @expand-change="expandChanged">
             <el-table-column type="expand">
                <template slot-scope="slot">
                    <el-table :stripe='true' :data="slot.row.balance" :header-cell-style='{background:"#33CC8D",color:"#ffffff"}' style="width: calc(100% - 47px)" size="medium">
                        <el-table-column align="center" prop="dr_name" label="优惠券名"></el-table-column>
                        <el-table-column align="center" prop="md_remain_value" label="剩余额度(张)"></el-table-column>
                        <el-table-column align="center" label="操作">
                          <template slot-scope="scope">
                            <el-link type="primary" @click="ReCharge(scope.row)">充值</el-link>
                            <el-link type="primary" @click="DeCharge(scope.row)">退费</el-link>
                          </template>
                        </el-table-column>
                    </el-table>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="mc_name" label="商家名称"></el-table-column>
            <el-table-column align="center" prop="mc_contacts" label="联系人"></el-table-column>
            <el-table-column align="center" prop="mc_phone" label="联系方式"></el-table-column>
            <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                    <el-link type="primary" @click="UserClick(scope.row)">操作员</el-link>
                    <el-link type="primary" @click="EditClick(scope.row)">修改</el-link>
                    <el-link type="danger" @click="DelClick(scope.row)">删除</el-link>
                    <!-- <el-link type="primary" @click="FixCode(scope.row)">固定码管理</el-link> -->
                </template>
            </el-table-column>
        </el-table>

        <el-dialog :title="title" :visible.sync="dialogVisible" :width='screenWidth<738?"50%":(screenWidth<1200?"40%":"30%")' :append-to-body='true'>
            <el-form :model="merForm" :rules="rules" ref="merForm" label-width="100px" size='medium'>
                <el-form-item label="商家名称" prop="mc_name">
                    <el-input v-model="merForm.mc_name"></el-input>
                </el-form-item>
                <el-form-item label="联系人">
                    <el-input v-model="merForm.mc_contacts"></el-input>
                </el-form-item>
                <el-form-item label="联系方式">
                    <el-input v-model="merForm.mc_phone"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog v-if="userDialogVisible" :title="title" :visible.sync="userDialogVisible" width='80%' :append-to-body='true'>
            <merUser :beglongId='merId' :userType="6"/>
            <span slot="footer" class="dialog-footer">
                <el-button @click="userDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </span>
        </el-dialog>


        
        <el-dialog v-if="rechargeDialogVisible" title="商户充值" :visible.sync="rechargeDialogVisible" width='65%' :append-to-body='true'>
          <el-card v-if="showDis">
            <div slot="header" class="clearfix">
              <span>选择优惠券</span>
            </div>
            <div  v-for="(page, index) of pages" :key="index" style="display: flex;flex-direction: row;" >
              <div v-for="item of page" :key="item.dr_id" style="margin-bottom: 10px;" class="corner-hollow-coupon " :class="[item.check?'check':'uncheck']" @click='checkDic(item.dr_id)'>
                <div class="coupon-big-price">¥{{item.dr_price}}元</div>
                <div class="coupon-info">
                  <h3>{{item.dr_name}}</h3>
                  <h5>单张额度:{{item.dr_type===0?(item.dr_value+'分钟'):(item.dr_type===1?(item.dr_value/100+'元'):(item.dr_type===2?(item.dr_value/100+'折'):(item.dr_limit_num===0?'不限使用次数':('限使用'+item.dr_limit_num+'次'))))}}</h5>
                </div>
              </div>
            </div>
          </el-card>
          <br/>
          <el-form :model="rechargeForm" ref="rechargeForm" label-width="100px" size='medium'>
            <el-form-item v-if="showDis" label="商家">
              <el-select v-model="rechargeForm.mr_mc_id" multiple placeholder="请选择" style="width: 300px;"> 
                <el-option :key="0" label="车场管理方-停车场" :value="0"></el-option>
                <el-option  v-for="item in MerListData" :key="item.mc_id" :label="item.mc_name" :value="item.mc_id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item  :label="rechargeForm.opt_type===0?'充值数量':'退款数量'">
                <el-input-number v-model.number="rechargeForm.mr_num" style="width:300px" controls-position="right" :precision="0" :min="1" @change='numChanged'></el-input-number>张
            </el-form-item>
            <el-form-item :label="rechargeForm.opt_type===0?'应收金额':'应退金额'">
              <el-input-number v-model="rechargeForm.should_charge" controls-position="right" :disabled="true" :precision="2" :min="0" style="width:300px"></el-input-number>元
            </el-form-item>
            <el-form-item :label="rechargeForm.opt_type===0?'实收金额':'实退金额'">
                  <el-input-number v-model="rechargeForm.mr_charge" controls-position="right" :precision="2" :min="0" style="width:300px"></el-input-number>元
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
              <el-button @click="rechargeDialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="Save">确 定</el-button>
          </span>
        </el-dialog>
        





    </div>
</template>

<script>
import util from '../../util/util'
import merUser from '../../components/servicer/SerUser.vue'

export default {
  data: function () {
    return {
      screenWidth: 0,
      MerListData: [],
      DisRulesDataList: [],

      dialogVisible: false,
      title: '',
      merForm: {
        mc_id: 0,
        mc_name: '',
        mc_contacts: '',
        mc_phone: ''
      },
      rules: {
        mc_name: [{ required: true, message: '请输入商家名称', trigger: 'blur' }],
        num: [{ required: true, message: '请输入充值数量' }, { type: 'number' }],
        charge: [{ type: 'number', required: true, message: '请输入实收金额', trigger: 'blur' }]
      },
      userDialogVisible: false,

      showDis:true,//是否展示折扣券和商家
      rechargeDialogVisible: false,
      rechargeForm:{
        opt_type: 0,
        mr_mc_id:[],
        mr_dis_id:0,
        mr_num:0,
        should_charge:0.00,
        mr_charge:0.00,
      },
    

      fixCodeDialogVisible:false,
      FixDisDataList:[],//配置固定码时商户当前使用的折扣信息
    }
  },
  components: {
    merUser,
  },
  created () {
    this.screenWidth = document.body.clientWidth
    util.Get("disrules/GetDisRulesDataList").then(res=>{
      if(res.rpStatus===10000){
          if(res.list.length>0){
            res.list.forEach(item => {
              item.check=false
              this.DisRulesDataList.push(item)
            });
        }
        this.DisRulesDataList[0].check=true//默认选中一个
        this.rechargeForm.mr_dis_id=this.DisRulesDataList[0].dr_id
      }
    })
    this.GetMerDataList()
  },
  computed: {
    pages () {
      const pages = []
     
      this.DisRulesDataList.forEach((item, index) => {
        
        const page = Math.floor(index / 4)// 4条为一行
        if (!pages[page]) {
          pages[page] = []
        }
        pages[page].push(item)
      })
      return pages
    },
  },
  methods: {
    GetMerDataList () {
      this.MerListData=[]
      util.Get('merchant/getmerchantdatalist').then(res => {
        if (res.rpStatus === 10000) {
          res.list.forEach(item=>{
            item.balance=[]
            this.MerListData.push(item)
          })
        }
      })

      
    },
    
    //商家
    AddClick () {
      if(util.CheckUserAuth('3-2-1')){
        this.dialogVisible = true
        this.title = '新增'
        this.merForm.mc_id = 0
        this.merForm.mc_name = ''
        this.merForm.mc_contacts = ''
        this.merForm.mc_phone = ''
      }
    },
    EditClick (row) {
      if(util.CheckUserAuth('3-2-2')){
        this.merForm = JSON.parse(JSON.stringify(row))
        this.dialogVisible = true
        this.title = '修改'
      }
    },
    DelClick (row) {
      if(util.CheckUserAuth('3-2-3')){
        this.$confirm('确定删除商家“' + row.mc_name + '”？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          util.Get('merchant/del?id=' + row.mc_id+'&name='+row.mc_name).then(res => {
            if (res.rpStatus === 10000) { this.GetMerDataList() } else { this.$message.error(res.rpMsg) }
          })
        }).catch(e => e)
      }
    },
    submit () {
      this.$refs.merForm.validate((valid) => {
        if (valid) {
          util.Post('merchant/edit', this.merForm).then(res => {
            if (res.rpStatus === 10000) {
              this.GetMerDataList()
              this.dialogVisible = false
            } else { this.$message.error(res.rpMsg) }
          })
        }
      })
    },
    
    //操作员
    UserClick (row) {
      if(util.CheckUserAuth('3-2-4')){
        this.userDialogVisible = true
        this.title = '操作员'
        this.merId = row.mc_id
      }
    },
    
    //充值
    Recharge(){
      if(util.CheckUserAuth('3-2-5')){
        this.showDis=true
        this.rechargeDialogVisible=true
        this.rechargeForm.opt_type= 0
        this.rechargeForm.mr_mc_id=[]
        this.rechargeForm.mr_num=1
        this.rechargeForm.mr_charge=this.DisRulesDataList[0].dr_price
        this.rechargeForm.should_charge=this.DisRulesDataList[0].dr_price
      }
    },
    numChanged(currentValue, oldValue){
      if(this.rechargeForm.mr_dis_id===0){
        this.$message.error('请选择优惠券')
        return
      }
      this.computedPrice(currentValue)
    },
    checkDic(id){
      this.DisRulesDataList.forEach(a=>{
        a.check=false
        if(a.dr_id===id){
          a.check=true
          this.rechargeForm.mr_dis_id=id
          this.computedPrice(this.rechargeForm.mr_num)
        }
      })
    },
    computedPrice(currentValue){
      let arr= this.DisRulesDataList.filter(a=>a.dr_id===this.rechargeForm.mr_dis_id)
      let val= currentValue* arr[0].dr_price
      this.rechargeForm.mr_charge=val
      this.rechargeForm.should_charge=val
    },

    //查看余额
    expandChanged(row,expandedRows){
      if(expandedRows.length>0){
        util.Get('merchant/getmerremainbalance?id='+row.mc_id).then(res=>{
          let arr=this.MerListData.filter(a=>a.mc_id===row.mc_id)
          arr[0].balance=res.list
        })
      }
    },


    //单独商户充值
    ReCharge (disRow) {
      if(util.CheckUserAuth('3-2-5')){
        this.rechargeDialogVisible = true
        this.title = '充值'
        this.showDis=false
        this.rechargeForm.mr_dis_id=disRow.md_dr_id
        this.rechargeForm.opt_type= 0
        this.rechargeForm.mr_mc_id.push(disRow.md_mc_id)
        this.rechargeForm.mr_num=1
        let arr= this.DisRulesDataList.filter(a=>a.dr_id===disRow.md_dr_id)
        this.rechargeForm.mr_charge=arr[0].dr_price
        this.rechargeForm.should_charge=arr[0].dr_price
      }
    },


    DeCharge (disRow) {
      if(util.CheckUserAuth('3-2-6')){
        this.showDis=false
        this.rechargeDialogVisible = true
        this.rechargeForm.opt_type = 1
        this.title = '退费'

        this.rechargeForm.mr_dis_id=disRow.md_dr_id

        this.rechargeForm.mr_mc_id.push(disRow.md_mc_id)
        this.rechargeForm.mr_num=1
        let arr= this.DisRulesDataList.filter(a=>a.dr_id===disRow.md_dr_id)
        this.rechargeForm.mr_charge=arr[0].dr_price
        this.rechargeForm.should_charge=arr[0].dr_price
      }
    },
    Save () {
      if(this.rechargeForm.mr_mc_id.length===0){
        this.$message.error('请选择充值的商户')
        return
      }
      util.Post('merchant/recharge', this.rechargeForm).then(res => {
        if (res.rpStatus === 10000) {
          this.GetMerDataList()
          this.rechargeDialogVisible = false
          this.$message({
            message: this.rechargeForm.opt_type === 0 ? '充值成功' : '退费成功',
            type: 'success'
          })
        } else { this.$message.error(res.rpMsg) }
      })
    },


  }
}
</script>

<style scoped>
.content{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.el-table{
    margin-top: 10px;
}
.el-link{
    margin-right: 10px;
    font-size: 12px;
}
::v-deep .el-dialog{
  --el-bg-color:#000741 !important;
}
::v-deep .el-dialog__header{
  --el-text-color-primary:#1effff;
  --el-text-color-regular:#fff;
  padding: 0px !important;
  background-color: #309CE2;
  height: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep .el-dialog__title{
    color: white;
}

::v-deep .el-dialog__headerbtn .el-dialog__close{
    color: white;
} 






.corner-hollow-coupon {
    width: calc(33.33% - 28px);
    height: 80px;
    text-align: center;
    position: relative;
    filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.15));
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-left: 20px;
    cursor:pointer
}
.check{
  color: #fff;
  background: 
        radial-gradient(circle at right bottom, transparent 8px, #27d089 0) top right / 50% 40px no-repeat,
        radial-gradient(circle at left bottom, transparent 8px, #27d089 0) top left / 50% 40px no-repeat,
        radial-gradient(circle at right top, transparent 8px, #27d089 0) bottom right / 50% 40px no-repeat,
        radial-gradient(circle at left top, transparent 8px, #27d089 0) bottom left / 50% 40px no-repeat;
}
.uncheck{
  color:black;
  background: 
        radial-gradient(circle at right bottom, transparent 8px, #ccc 0) top right / 50% 40px no-repeat,
        radial-gradient(circle at left bottom, transparent 8px, #ccc 0) top left / 50% 40px no-repeat,
        radial-gradient(circle at right top, transparent 8px, #ccc 0) bottom right / 50% 40px no-repeat,
        radial-gradient(circle at left top, transparent 8px, #ccc 0) bottom left / 50% 40px no-repeat;
}




.coupon-big-price {
    font-size: 18px;
    height: 100%;
    display: flex;
    width: 40%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    border-right: 2px dashed #fff;
}
.coupon-info {
    text-align: center;
    padding: 10px;
}
</style>
